import { ReactNode } from 'react'
import { LuKeyRound, LuMail, LuSmartphone } from 'react-icons/lu'
import { TMfaMethodType } from 'dtos/User'

// Fonte única do ícone/rótulo/descrição de cada método 2FA — reaproveitado em
// TwoFactorLoginGate (login) e TwoFactorSettings (gestão), pra não desenhar o
// mesmo conceito 2 vezes. Espelha o padrão já validado em
// manager-cannect/src/utils/mfaMethodPresentation.tsx, com os ícones da
// família já usada neste repo (react-icons/lu, ex. LuShieldCheck).
export const MFA_METHOD_ICON: Record<TMfaMethodType, ReactNode> = {
  email: <LuMail size={20} />,
  sms: <LuSmartphone size={20} />,
  totp: <LuKeyRound size={20} />
}

export const MFA_METHOD_LABEL: Record<TMfaMethodType, string> = {
  email: 'E-mail',
  sms: 'SMS',
  totp: 'Aplicativo autenticador'
}

export const MFA_METHOD_DESCRIPTION: Record<TMfaMethodType, string> = {
  email: 'Receba um código no seu e-mail cadastrado',
  sms: 'Receba um código por mensagem de texto',
  totp: 'Google Authenticator, Authy ou similar'
}
